import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './lib/mixpanel'; // Initialize Mixpanel (autocapture + session replay)
import { initializeApiClient } from './services/api-client';
import { config } from './config/environment';
import { AppErrorBoundary } from './components/app-error-boundary';

initializeApiClient({ baseUrl: config.apiUrl });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
